<div class="kt-portlet kt-portlet--responsive-mobile">
  <div class="kt-portlet__head">
    <div class="kt-portlet__head-label">
      <h2 class="kt-portlet__head-title text-capitalize">
        Request For Quotes | <b> Inventory </b> Default Channel Shipping
      </h2>
    </div>
    <div class="kt-portlet__head-toolbar"></div>
  </div>

  <div
    class="kt-portlet__body"
    *ngIf="shippingCarriers$ | async as shippingCarriers"
  >
    <div class="filters form-inline">
      <label for="" class="mr-2">FILTER SKU: </label>
      <div class="form-group form-inline mr-2">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="filter.keyword"
          (keyup.enter)="getRecords(false, 1)"
        />
      </div>
    </div>

    <div *ngIf="gettingRecords$ | async">
      <div class="text-center">
        <br />
        <h3 [translate]="'GENERAL.GETTING_RECORDS'">
          <i class="fas fa-spinner fa-spin"></i>
          Getting records...
        </h3>
        <br />
      </div>
    </div>

    <div *ngIf="!(gettingRecords$ | async) && records.data.length === 0">
      <div class="text-center">
        <br />
        <h6 class="text-warning">No record found.</h6>
        <br />
      </div>
    </div>

    <div
      class="overflow-auto"
      *ngIf="!(gettingRecords$ | async) && records.data.length > 0"
    >
      <table class="table table-striped" *ngIf="loadingRfqs <= 0">
        <thead>
          <tr>
            <th #skuContainer>SKU</th>
            <th [ngStyle]="{ left: skuContainer.offsetWidth + 'px' }">
              Product Name
            </th>
            <th *ngFor="let ch of channels">{{ ch.label }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let rfq of records.data; let i = index">
            <td>{{ rfq.internal_sku || 'N/A' }}</td>
            <td [ngStyle]="{ left: skuContainer.offsetWidth + 'px' }">
              {{ rfq.product_name }}
            </td>
            <td *ngFor="let ch of rfq.channels">
              <select
                name="default_shipping"
                id="default_shipping"
                class="form-control-sm"
                [(ngModel)]="ch.shipping_carrier_id"
                (change)="updateChannelShipping(rfq, ch)"
              >
                <option *ngFor="let ch of shippingCarriers.data" [value]="ch.id">
                  {{ ch.carrier_name }}
                </option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <mat-paginator
      [length]="records.total"
      [pageSize]="records.per_page"
      [pageSizeOptions]="pageSizeOptions"
      (page)="getRecords($event)"
    >
    </mat-paginator>
  </div>
</div>
